//import * as Im from 'immutable';
import * as model from "../models";
import * as ui from "../models/ui";

import { CategoryFormActions, CategoryActions, SaveCategories } from "../actions"
let uuid = require('uuid');
export const CATEGORY_TYPES: string[] = ["CATEGORY_1", "CATEGORY_2", "CATEGORY_3", "CATEGORY_4", "CATEGORY_5", "CATEGORY_6", "CATEGORY_7",
	"CATEGORY_8", "CATEGORY_9", "CATEGORY_10"]
export const CATEGORY_NAMES: string[] = ["Kategorie 1", "Kategorie 2", "Kategorie 3", "Kategorie 4", "Kategorie 5", "Kategorie 6", "Kategorie 7",
	"Kategorie 8", "Kategorie 9", "Kategorie 10"]

export const CATEGORY_COLORS: string[] = ["#00ff00", "#0000ff", "#ffff00", "#660000", "#9900ff", "#00ffff",	"#274e13", "#ff9900", "#ff00ff", "#000000"];

export interface CategoryFormState {
	updateUi: boolean
	displayCategories: ui.DisplayCategory[];
	globalFees: ui.FeeCollection
	displayGlobalFees: boolean
	displayGlobalFeeWarning: boolean
	queryForceDelete: ui.DisplayCategory
	queryForceDeletePriceLevel: model.PriceLevel
	loading: boolean;

};

const initialState: CategoryFormState  = {
	displayCategories: [],
	globalFees: ui.FeeCollection.create(),
	updateUi: false,
	displayGlobalFees: true,
	displayGlobalFeeWarning: false,
	queryForceDelete: null,
	queryForceDeletePriceLevel: null,
	loading: false

}


export const categoryFormReducer = (state = initialState, action): CategoryFormState => {
	switch (action.type) {

		case CategoryFormActions.NEW_DISPLAY_CATEGORIES:
			const displayCategories: ui.DisplayCategory[] = action.payload;
			let globalFee = getGlobalFees(displayCategories);
			if (displayCategories.length === 0) globalFee = ui.FeeCollection.create()
			return {
				displayCategories: action.payload,
				updateUi: true,
				globalFees: globalFee,
				displayGlobalFees: globalFee ? true : false,
				displayGlobalFeeWarning: state.displayGlobalFeeWarning,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading

			}


		case CategoryFormActions.DISPLAY_CATEGORY_CHANGE:
			const displayCategory: ui.DisplayCategory = action.payload;
			displayCategory.combinedPriceLevel.standard.price.vat = displayCategory.category.vat;
			//muss das hier immutable sein? ich glaube die action kann man mutieren.
			for (let reduced of displayCategory.combinedPriceLevel.reduced) {
				reduced.price.vat = displayCategory.category.vat;
			}
			const newDC =  state.displayCategories.map(dc => dc.category.uuid == action.payload.category.uuid ? action.payload : dc)
			return {
				displayCategories: newDC,
				updateUi: false,
				globalFees: getGlobalFees(newDC),
				displayGlobalFees: state.displayGlobalFees,
				displayGlobalFeeWarning: state.displayGlobalFeeWarning,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading


			}


		case CategoryFormActions.ADD_DISPLAY_CATEGORY:
				const length = state.displayCategories.length >= CATEGORY_TYPES.length ? CATEGORY_TYPES.length - 1 : state.displayCategories.length;
				const newCat = new model.Category()
				newCat.type = CATEGORY_TYPES[length]
				newCat.name = CATEGORY_NAMES[length]
				newCat.color = CATEGORY_COLORS[length]
				newCat.uuid = uuid.v4();
				const vats = state.displayCategories.map(dc => dc.category.vat)
				if (vats.length === 0) {
					newCat.vat = 19
				} else {
					const maxVat = Math.max(...vats);
					newCat.vat = maxVat || 19
				}

				let standardPrice = model.PriceLevel.create()
				standardPrice.name = "Standard"
				if (state.displayGlobalFees) {
					standardPrice.ticketFees = ui.FeeCollection.toList(state.globalFees)
				}
				const dc: ui.DisplayCategory = {
					category: newCat,
					combinedPriceLevel: {
						categoryID: newCat.uuid,
						standard: standardPrice,
						reduced: []
					}
				}
				return {
					displayCategories: [...state.displayCategories, dc],
					updateUi: true,
					globalFees: state.globalFees,
					displayGlobalFees: state.displayGlobalFees,
					displayGlobalFeeWarning: state.displayGlobalFeeWarning,
					queryForceDelete: null,
					queryForceDeletePriceLevel: null,
					loading: state.loading


				}


		case CategoryFormActions.ADD_REDUCED_PRICELEVEL: {
			const findDisplayedCategory = state.displayCategories.find(dc => dc.category.uuid == action.payload)
			const newPriceLevel = model.PriceLevel.create();
			if (state.displayCategories) {
				newPriceLevel.ticketFees = ui.FeeCollection.toList(state.globalFees);
			}
			const newReduced = [...findDisplayedCategory.combinedPriceLevel.reduced, newPriceLevel]

			const newCombined = Object.assign({}, findDisplayedCategory.combinedPriceLevel, {
				reduced: newReduced
			})
			const newDC = Object.assign({}, findDisplayedCategory, { combinedPriceLevel: newCombined })
			return {
				updateUi: true,
				displayCategories: state.displayCategories.map(dc => dc.category.uuid == action.payload ? newDC : dc),
				globalFees: state.globalFees,
				displayGlobalFees: state.displayGlobalFees,
				displayGlobalFeeWarning: state.displayGlobalFeeWarning,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading


			}
		}

		case CategoryFormActions.TOGGLE_GLOBAL_FEES:
			let displayGlobalFees = false
			let displayGlobalFeeWarning = false;
			if (state.globalFees && state.displayGlobalFees === false) {
				displayGlobalFees = true
			}
			if (!state.globalFees && state.displayGlobalFees === false) {
				displayGlobalFeeWarning = true;
			}
			if (state.displayGlobalFees === false && state.globalFees) {
				displayGlobalFees = true;
			}

			return {
				updateUi: true,
				displayCategories: state.displayCategories,
				globalFees: state.globalFees,
				displayGlobalFees: displayGlobalFees,
				displayGlobalFeeWarning: displayGlobalFeeWarning,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading

			}

		case CategoryFormActions.NEW_GLOBAL_FEES: {
			const newDCs = updateFeesToGlobal(state.displayCategories, action.payload)

			return {
				updateUi: true,
				displayCategories: newDCs,
				globalFees: action.payload,
				displayGlobalFees: state.displayGlobalFees,
				displayGlobalFeeWarning: state.displayGlobalFeeWarning,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading

			}
		}

		case CategoryFormActions.CANCEL_GLOBAL_FEE_WARNING:
			return Object.assign({}, state, {displayGlobalFeeWarning: false})

		case CategoryFormActions.FORCE_EMPTY_GLOBAL_FEE:
			const globalFees = ui.FeeCollection.create();
			const newDCs = updateFeesToGlobal(state.displayCategories, globalFees)
			return {
				updateUi: true,
				displayCategories: newDCs,
				globalFees: globalFees,
				displayGlobalFees: true,
				displayGlobalFeeWarning: false,
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: state.loading

			}

		case CategoryFormActions.DELETE_CATEGORY: {
			const dc: ui.DisplayCategory = <ui.DisplayCategory>action.payload;
			if (dc.category._links) {
				return Object.assign({}, state, { queryForceDelete: dc })
			} else {
				const index = state.displayCategories.map(dc => dc.category.uuid).indexOf(dc.category.uuid);
				const newDCs = [...state.displayCategories]
				newDCs.splice(index, 1);
				return Object.assign({}, state, { displayCategories: newDCs, updateUi: true })
			}
		}

		case CategoryFormActions.CANCEL_CATEGORY_DELETE:
			return Object.assign({}, state, { queryForceDelete: null })

		case CategoryFormActions.FORCE_CATEGORY_DELETE_SUCCESS: {
				const index = state.displayCategories.indexOf(state.queryForceDelete);
				const newDCs = [...state.displayCategories]
				newDCs.splice(index, 1);
				return Object.assign({}, state, {
					displayCategories: newDCs,
					queryForceDelete: null
				})
		}

		case CategoryFormActions.DELETE_REDUCED_PRICELEVEL: {
			const priceLevel: model.PriceLevel = action.payload.priceLevel;
			const displayCategory: ui.DisplayCategory = action.payload.displayCategory;
			if (priceLevel._links) {
				return Object.assign({}, state, {
					queryForceDeletePriceLevel: priceLevel
				})
			} else {
				let newReduced = displayCategory.combinedPriceLevel.reduced.filter(reducedPriceLevel => reducedPriceLevel.uuid !== priceLevel.uuid)
				newReduced  = newReduced || []
				const newDC = Object.assign({}, displayCategory, {
					combinedPriceLevel: {
						categoryID: displayCategory.combinedPriceLevel.categoryID,
						standard: displayCategory.combinedPriceLevel.standard,
						reduced: newReduced
					}
				})
				const newDCs = state.displayCategories.map(dc => dc.category.uuid === newDC.category.uuid ? newDC : dc)
				return Object.assign({}, state, {
					displayCategories: newDCs,
					updateUi: true
				})
			}
		}

		case CategoryFormActions.CANCEL_DELETE_REDUCED_PRICELEVEL:
			return Object.assign({}, state, {
				queryForceDeletePriceLevel: null
			})

		case CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL_SUCCESS: {
			const dc = state.displayCategories.find(dc => dc.combinedPriceLevel.reduced.find(pl => pl.uuid === state.queryForceDeletePriceLevel.uuid) != null)
			const newReduced = dc.combinedPriceLevel.reduced.filter(r => r.uuid !== state.queryForceDeletePriceLevel.uuid)
			const newCombined = {
				categoryID: dc.category.uuid,
				standard: dc.combinedPriceLevel.standard,
				reduced: newReduced
			}
			const newDC = Object.assign({}, dc, {
				combinedPriceLevel: newCombined
			})
			const newDCs = state.displayCategories.map(dc => dc.category.uuid === newDC.category.uuid ? newDC : dc);

			return Object.assign({}, state, {
				queryForceDeletePriceLevel: null,
				displayCategories: newDCs
				})
		}

		case CategoryFormActions.SAVE_DISPLAY_CATEGORY:
			return Object.assign({}, state, { loading: true });

		case CategoryFormActions.CATEGORY_AND_PRICELEVEL_SAVED:
			return Object.assign({}, state, { loading: false });

		case CategoryFormActions.CATEGORY_FORM_ERROR:
			return Object.assign({}, state, {
				queryForceDelete: null,
				queryForceDeletePriceLevel: null,
				loading: false
			})

		default: return state;
	}

}

const updateFeesToGlobal = (displayCategories: ui.DisplayCategory[], fee: ui.FeeCollection) => {
	const newDCs: ui.DisplayCategory[] = JSON.parse(JSON.stringify(displayCategories))
	for (let dc of newDCs) {
		dc.combinedPriceLevel.standard.ticketFees = ui.FeeCollection.toList(fee)
		for (let reduced of dc.combinedPriceLevel.reduced) {
			reduced.ticketFees = ui.FeeCollection.toList(fee)
		}
	}
	return newDCs;
}

const getGlobalFees = (displayCategories: ui.DisplayCategory[]) => {
	let feeCollectionsForCategory: ui.FeeCollection[][] = displayCategories.map(dc => {
		if (!dc.combinedPriceLevel) return [];
		return [
			ui.FeeCollection.fromTicketFeeList(ui.FeeCollection.create(), dc.combinedPriceLevel.standard.ticketFees)
			, ...dc.combinedPriceLevel.reduced.map(reduced =>
				ui.FeeCollection.fromTicketFeeList(ui.FeeCollection.create(), reduced.ticketFees)
			)
		]
	})
	let feeCollections: ui.FeeCollection[] = [].concat(...feeCollectionsForCategory);
	let allFeeCollectionsAreEqual = feeCollections.every(fc => ui.FeeCollection.equal(fc, feeCollections[0]))
	let globalFee = null
	let displayGlobalFee = false;
	if (allFeeCollectionsAreEqual) {
		globalFee =  feeCollections[0] || globalFee;
		displayGlobalFee = true;
	}
	return globalFee;
}



// WEBPACK FOOTER //
// ./src/app/reducers/category-form.reducer.ts